/* src/app/umbrella-common/components/text-area-component/text-area.style.scss */
.text-area-wrapper {
  display: flex;
  flex-direction: column;
}
.text-area-wrapper .with-description {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text-area-wrapper .with-description label {
  margin-bottom: 0;
}
.text-area-wrapper .with-description nb-icon {
  margin-bottom: 5px;
}
.text-area-wrapper label {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  font-family: Arial, sans-serif;
  color: #007d40;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.text-area-wrapper textarea {
  min-height: 80px;
  max-height: 200px;
  max-width: 100% !important;
  margin-top: 8px;
}
nb-card.description-card {
  margin-bottom: 0 !important;
  border: none !important;
}
nb-card.description-card .description-body {
  width: 470px;
  height: 118px;
  padding: 10px 12px !important;
  border-radius: 4px;
  border: solid 1px #0044b1;
  background-color: #ffffff;
}
nb-card.description-card .description-body .label {
  font-size: 15px;
  font-family: Arial, sans-serif;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.47;
  color: #585858;
  max-width: 420px;
  float: left;
}
nb-card.description-card .description-body .close-icon {
  cursor: pointer;
  vertical-align: middle;
  color: #0044b1 !important;
  float: right;
}
nb-card.description-card .header {
  background-color: #0044b1;
}
nb-card.description-card .header nb-icon {
  float: right;
  color: white;
}
nb-card.description-card.mobile .description-body {
  border-radius: 0;
  border: none;
}
@media screen and (max-width: 767px) {
  .description-card.mobile {
    width: 100%;
    height: 100%;
  }
  .description-card.mobile .description-body {
    width: 100%;
  }
}
@media screen and (max-width: 479px) {
  .description-card.mobile {
    width: 100%;
    height: 100%;
  }
  .description-card.mobile .description-body {
    width: 100%;
  }
}
/*# sourceMappingURL=text-area.style.css.map */
